export default [
  { 
    // 路由写好注释： 栏目 + 文件名 + 页面名
    path: '/auth',
    component: resolve => require(['./Index'], resolve),
    redirect: '/auth/index',
    children: [
      {
        // 组织人员管理
        path: 'personnel',
        component: resolve => require(['./view/Personnel'], resolve),
        // meta: {
        //   parent: "/auth/personnel"
        // }
      },
      {
        // 角色人员管理
        path: 'roleList',
        component: resolve => require(['./view/RoleList'], resolve),
        meta: {
          parent: "/auth/roleList",
          keepAlive: true
        }
      },
      {
        // 新建角色
        path: 'newRole',
        component: resolve => require(['./view/NewRole'], resolve),
        meta: {
          parent: "/auth/roleList",
          isBack:true
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/auth/router.js